import $ from 'jquery'

export default {
    name: 'assure-medicaments',
    components: {},
    props: {
        list_exclu_medicaments: Array
    },
    data() {
        return {
            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_MEDICAMENT', this.one_is_checked)
        }
    },

    computed: {
        // Catégorie des médicaments
        liste_medicaments_by_categorie() {
            return this.$store.getters["liste_medicaments_by_categorie"];
        },
    },

    mounted() {
        this.one_is_checked = []
		this.each_cat_is_checked = []

        this.listeMedicaments()
    },

    methods: {
        listeMedicaments() {
            this.$store.dispatch('getListeMedicamentsParCategorie').then(() => {
                if (this.liste_medicaments_by_categorie.length > 0) {
                    this.setSelectedTypeAnalyses()
                } 
            })
        },

        setSelectedTypeAnalyses() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_medicaments.forEach(exclusion => {
                this.liste_medicaments_by_categorie.forEach(categorie_medicament => {
					categorie_medicament.medicaments.forEach((medicament) => {
						if (exclusion.id == medicament.medicament_id) {
							this.text_grey[medicament.medicament_id] = 'text-grey'
							this.one_is_checked.push(medicament.medicament_id)
						}
					}) 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#medoc-tous').is(":checked")

            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.liste_medicaments_by_categorie.forEach((categorie_medicament) => {
                if (is_checked) {
                    this.each_cat_is_checked.push(categorie_medicament.categorie_id)
                }

                categorie_medicament.medicaments.forEach((_data) => {
                    this.text_grey[_data.medicament_id] = (is_checked)?'text-grey':''

                    if (is_checked) {
                        this.one_is_checked.push(_data.medicament_id)
                    }
                })
            });
            
            this.all_checked = is_checked
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#catmed-tous'+index).is(":checked")

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.liste_medicaments_by_categorie.forEach((categorie_medicament) => {
                if (categorie_medicament.categorie_id == index) {
                    categorie_medicament.medicaments.forEach((_data) => {
                        this.text_grey[_data.medicament_id] = (is_checked)?'text-grey':''

                        if (is_checked) {
                            this.one_is_checked.push(_data.medicament_id)
                        } else {
                            let index_of = this.one_is_checked.indexOf(_data.medicament_id)
                            if (index_of > -1) {
                                this.one_is_checked.splice(index_of, 1)
                            }
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },

        onExclu() {
            // TODO
        },
    }
}